module.exports = __webpack_public_path__ + "images/ace9f4348981c9fa751219a1a5b3ee66.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-characters00.jpg
// module id = ./webpack/assets/img/wheels-characters00.jpg
// module chunks = 0